export default __webpack_public_path__ + "static/media/wegovy-check-clarity.fbc5d73a.mp4";